export const CONFIRMATION_TEXT = `
By checking this box, I confirm and declare the following:

Truthfulness and Accuracy of Information I affirm that all information I have provided in connection with this insurance application is true, accurate, complete, and up to date to the best of my knowledge and belief.

Duty of Disclosure I understand my obligation to promptly disclose any material changes or inaccuracies to the information provided, including prior to the issuance of the policy.

Acknowledgement of Responsibilities I acknowledge that providing false, inaccurate, or misleading information may result in the denial of claims, cancellation of the policy, or other legal consequences as specified under applicable laws and the terms of the insurance policy.

Review of Documentation I acknowledge that it is my responsibility to review all the information and declarations related to this insurance product to reflect my understanding and agreement.

Consent and Authority By checking this box, I agree to the terms of this service and acknowledge my responsibilities under this agreement.
`;
